import React from "react";
import { LogIn, FileText, Tag, Image as ImageIcon, Compass, Palette, Inbox, Settings } from "lucide-react";

const STEPS = [
  {
    icon: LogIn, title: "Logging in",
    body: "Go to your website address followed by /admin (or click “Owner Login” at the bottom of any page). Sign in with your email and password. If you forget your password, click “Forgot your password?” and a secure reset link will be emailed to you. You can change your password anytime under Website Settings.",
  },
  {
    icon: FileText, title: "Editing pages",
    body: "Open Pages & Sections and pick a page. Click any section to edit its text, photos, and buttons. Use the arrow buttons to reorder sections, the eye to hide one, and the copy/trash icons to duplicate or delete. Press “Save Page” when you're done — the History button lets you restore an earlier version if you change your mind.",
  },
  {
    icon: Tag, title: "Publishing promotions",
    body: "Open Promotions and click “New Promotion”. Add a title, photos, destination, description, optional price and dates, then set the status to Published. Tick “Featured” to also show it on the Home page. To stop showing an offer, switch it to Archived — or set an expiry date and it will hide itself automatically.",
  },
  {
    icon: ImageIcon, title: "Uploading photos",
    body: "Open Media Library and tap the upload area to add photos from your phone or computer (JPG, PNG, or WebP up to 5 MB — they're resized automatically for fast loading). Tap a photo to set its alt text and choose a focal point so the important part stays visible on small screens. When editing any page or promotion, “Choose image” lets you pick from this library.",
  },
  {
    icon: Compass, title: "Changing navigation and buttons",
    body: "Open Navigation & Buttons to rename menu tabs, reorder them with the arrows, hide a page from the menu, or change the “Plan Your Trip” button in the header. Button links inside each page are edited in Pages & Sections.",
  },
  {
    icon: Palette, title: "Changing the design",
    body: "Open Branding & Design to change your logo, colors, fonts, heading sizes, button shape, spacing, and social media links. The defaults are matched to your LD Travel logo, and every option keeps the site readable on phones.",
  },
  {
    icon: Inbox, title: "Viewing inquiries",
    body: "Open Customer Inquiries to read messages sent through your contact form. Each one is also emailed to you. Mark them In Progress or Completed as you follow up.",
  },
  {
    icon: Settings, title: "Website settings",
    body: "Open Website Settings to edit the consultation fee wording, the privacy notice, the browser-tab title, and to change your password.",
  },
];

export default function AdminGuide() {
  return (
    <div data-testid="admin-guide" className="max-w-3xl">
      <h2 className="font-heading text-3xl font-semibold text-[#0B1D3A] mb-2">Owner Guide</h2>
      <p className="text-slate-500 text-sm mb-8">Everything you can do with your website — no coding needed. Changes save permanently and appear on every device.</p>
      <div className="space-y-4">
        {STEPS.map((s) => (
          <div key={s.title} className="bg-white border border-slate-200 rounded-xl p-5 flex gap-4">
            <div className="w-10 h-10 rounded-xl bg-amber-100 flex items-center justify-center shrink-0">
              <s.icon className="w-5 h-5 text-amber-700" aria-hidden="true" />
            </div>
            <div>
              <h3 className="font-semibold text-[#0B1D3A]">{s.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed mt-1">{s.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
